.kdx-share-icons {
    display: flex;
    align-items: center;

    .heading { margin: 0 16px 8px 0; }
    ul {
        display: flex;
        align-items: center;
        padding: 0;
        margin: 0;
        list-style: none;
    }
    li {
        margin-right: 16px;
        padding-bottom: 8px;

        &:before { display: none; }
        &:last-child { 
            margin-right: 0;
            padding-bottom: 8px; 
        }
        a {
            display: inline-block;
            
            svg {
                @include svg-format(21px, 21px, currentColor);
                transition: transform .3s ease-in-out;
            }
            &:hover, &:focus { 
                svg { transform: scale(1.3); }
            }
        }
    }
    .copy-link {
        position: relative;
        
        .copy-modal {
            opacity: 0;
            position: absolute;
            bottom: calc(100% + 16px);            
            right: 100%;
            transform: translateX(50%);
            z-index: 10;
            background: #FFF;
            color: #000;
            @include text-size(14);
            @include line-height(18);            
            pointer-events: none;
            box-shadow: 3px 6px 8px rgba(0, 0, 0, 0.6);
            padding: 6px;
            white-space: nowrap;
            border-radius: 5px;
            transition: all .3s ease-in-out;            
            
            &.show {               
                animation: fadeInOut 5s;            
            }
        }
    }

    @keyframes fadeInOut {
        0% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
    }
}